import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { contact, images } from '../data/site';
export function CtaBand() {
  return <section className="relative w-full overflow-hidden" data-id="element-42" data-mp="hh5dp5dnmr1q">
      <img src={images.cta} alt="" className="absolute inset-0 h-full w-full object-cover" aria-hidden="true" data-id="element-43" data-mp="hfkirenfh63c" />
      <div className="absolute inset-0 bg-navy/85" aria-hidden="true" data-id="element-44" data-mp="rfl5lakia4ca" />

      <div className="relative mx-auto max-w-3xl px-6 py-20 text-center lg:py-24" data-id="element-45" data-mp="rdie0m3pg35g">
        <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-46" data-mp="vf3k9olqhj6o">
          Ready for a Cleaner Property?
        </h2>
        <p className="mt-4 text-[17px] text-white/80" data-id="element-47" data-mp="155oi39tl2joj">
          Contact Guernsey Cleaning today for a free, no-obligation quote.
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-6 sm:flex-row" data-id="element-48" data-mp="1a3q3i1ehev36">
          <a href={`mailto:${contact.email}`} className="flex items-center gap-2 text-white transition-colors hover:text-gold-light" data-id="element-49" data-mp="1f55qhz07zbo7">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="1u7il0aarzjff" />
            {contact.email}
          </a>
        </div>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-51" data-mp="1p9pcvbpwwfci">
          <a href={contact.phoneHref} className="flex items-center gap-3 bg-gold px-9 py-4 font-display text-[13px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-gold-dark" data-id="element-52" data-mp="1l96l1ho0r9ab">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-53" data-mp="2881rhczlehfh" />
            Call {contact.phone}
          </a>
          <Link to="/#contact" className="border border-white/50 px-9 py-4 font-display text-[13px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-navy" data-id="element-54" data-mp="246pwerxy93zw">
            Contact Us
          </Link>
        </div>
      </div>
    </section>;
}